import truncate from './text-truncate.js';

export const TITLE_MAX = 60;
export const SITE_NAME = 'Newspage';
export const SITE_SUFFIX = `| ${SITE_NAME}`;

export const ellipsise = (text, max) =>
    `${truncate(text, max - 2, true)
        .slice(0, -3)
        .replace(/[\s,;:.!?–—-]+$/, '')}…`;

const BASE_MAX = TITLE_MAX - SITE_SUFFIX.length - 1;

export default function pageTitle(base) {
    const text = typeof base === 'string' ? base.trim() : '';

    if (!text) {
        return SITE_NAME;
    }

    const full = `${text} ${SITE_SUFFIX}`;

    return full.length <= TITLE_MAX
        ? full
        : `${ellipsise(text, BASE_MAX)} ${SITE_SUFFIX}`;
}

// News and alert headlines are the page's reason to rank, so they get more
// room than pageTitle's 60, and the headline wins over the site suffix: the
// suffix goes first, then words from the end.
export const ARTICLE_TITLE_MAX = 70;

export function articleTitle(base) {
    const text = typeof base === 'string' ? base.trim() : '';

    if (!text) {
        return SITE_NAME;
    }

    const full = `${text} ${SITE_SUFFIX}`;

    if (full.length <= ARTICLE_TITLE_MAX) {
        return full;
    }

    return text.length <= ARTICLE_TITLE_MAX
        ? text
        : ellipsise(text, ARTICLE_TITLE_MAX);
}
